// Shared types for LocationAutocomplete component
export interface LocationData {
  name: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface LocationAutocompleteProps {
  apiKey: string;
  onLocationSelect: (location: LocationData) => void;
  placeholder?: string;
}

export interface PlacePrediction {
  place_id: string;
  description: string;
}
